import * as React from "react";

export const Header = () => (
  <header>
    <span className="about">O nás</span>
    <h1>TWU</h1>
    <div className="avatar">
      <img src='/images/logo.png' alt="twu" />
    </div>
  </header>
);
